import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import React from "react";
import { Pie } from "react-chartjs-2";

// Register required components for pie chart
ChartJS.register(ArcElement, Tooltip, Legend);

// Chart options
export const pieOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: false,
      text: "Pie Chart",
    },
  },
};

// PieChart component
const PieChart = ({ data }: { data: any }) => {
  return <Pie options={pieOptions} data={data} />;
};

export default PieChart;
